import { leadURL } from "@app/constants/ApiEndPoints";
import axios from "axios";

export const getLeadsWithPagination = async (search) => {
	try {
		const response = await axios.get(leadURL + `?${search.toString()}`);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getAllGotInTouch = async () => {
	try {
		const response = await axios.get(leadURL + '/got-in-touch');
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getAllFoundUsVia = async () => {
	try {
		const response = await axios.get(leadURL + '/found-us-via');
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getAllLeadStatus = async () => {
	try {
		const response = await axios.get(leadURL + '/status');
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const createLead = async (payload) => {
	try {
		const response = await axios.post(leadURL + '/create', payload);
		if (response.status === 201 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getLeadDetailsById = async (lead_id) => {
	try {
		const response = await axios.get(leadURL + `/${lead_id}` + '/journey');
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const updateLeadStatus = async (payload) => {
	try {
		const response = await axios.post(leadURL + '/journey', payload);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const addLeadSubject = async (payload) => {
	try {
		const response = await axios.post(leadURL + '/student/subject/create', payload);
		if (response.status === 201 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getLeadPercentageByFranchiseId = async (franchiseId, params) => {
	try {
		const response = await axios.get(leadURL + `/${franchiseId}` + '/enrolled-leads' + `?${params.toString()}`);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getConvertedLeadsByParent = async (parent_id) => {
	try {
		const response = await axios.get(leadURL + `/${parent_id}` + '/converted');
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getLeadDetailsBystudent = async (lead_student_id) => {
	try {
		const response = await axios.get(leadURL + `/student/${lead_student_id}/details`);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const updateEnrollmentDetailsBystudent = async (lead_student_id, payload) => {
	try {
		const response = await axios.post(leadURL + `/student/${lead_student_id}/details`, payload);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getProspectiveStudentsWithPagination = async (search) => {
	try {
		const response = await axios.get(leadURL + `/prospect?${search.toString()}`);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const activateStudentSubject = async (payload) => {
	try {
		const response = await axios.post(leadURL + '/prospect/student/subject', payload);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};


export const updateLeadDetails = async (lead_id,payload) => {
	try {
		const response = await axios.put(leadURL + `/${lead_id}`, payload);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};